import React from "react"
//import Layout from "../components/Layout"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"
import Footer from "../components/Footer"
import { OutboundLink } from "gatsby-plugin-google-analytics"



export default function Homepage() {
  return (

    <>
    <Helmet>
    <script defer src="https://use.fontawesome.com/releases/v5.3.1/js/all.js"></script>
<title>
        Innovation and China’s Global Emergence
    </title>
    </Helmet>

    <header> </header>

    <section className="hero is-small is-warning">
  <div className="hero-body">
    <div className="columns">
    <div className="column is-one-fifth">
    <figure classNam="image is4x5">
    <Link to="/">
    <img className="m-1" src="NUSPress_grey.png" /></Link>
    </figure>
    
  </div>
  <div className="column">

  <p className="title is-family-san-serif">Innovation and China’s Global Emergence</p>
    <p className="subtitle">
      edited by Erik Baark, Bert Hofman and Jiwei Qian
    </p>
    <div className="has-text-right">
    <p>ISBN: 978-981-325-148-9</p>
    <p>published August 2021</p>

    <p><OutboundLink href="https://nuspress.nus.edu.sg/collections/frontpage/products/innovation-and-chinas-global-emergence"><span class="icon">
  <i className="fas fa-book"></i></span>Buy the Book (Asia)</OutboundLink></p>
  <p><OutboundLink href="https://press.uchicago.edu/ucp/books/book/distributed/I/bo124042302.html"><span class="icon">
  <i className="fas fa-book"></i></span>Buy the Book (North America)</OutboundLink></p>
  <p>Or read this open access web edition</p>
  </div>
    </div></div>
  </div>
 
</section>






{/* <div className="tile is-ancestor  is-light-grey is-vertical "> */}


  <div className="tile is-ancestor m-4">
  <article className="tile is-child is-primary is-3">
    <a href="https://nuspress.nus.edu.sg/collections/frontpage/products/innovation-and-chinas-global-emergence"><img src="Innovation_cover_sm.jpg" height="42" className="ml-5" ></img></a>
    </article>
  <article className="tile is-child notification is-danger is-light is-fluid m-4">
  
  <p className="title is-2">1</p><p className="title is-4 is-family-sans-serif"><Link to="chapterone">Introduction</Link> </p>
			<p className="subtitle">Erik Baark, Bert Hofman and Jiwei Qian</p>
    </article>
    {/* <article className="tile is-3 is-child box m-4">
  
    <p className="subtitle is-4 px-3">Part One: Implications of China’s Innovation Emergence </p>
    <p className="subtitle is-4 px-3"></p>
    </article> */}
<article className="tile is-3 is-child notification is-white  m-4">
<p className="title is-2">2</p><Link to="chaptertwo"><p className="title is-4 is-family-sans-serif">China and the US: Technology Conflict or Cooperation? </p></Link>
			<p className="subtitle">Gary H. Jefferson</p>
    </article>

    <article className="tile is-3 is-child notification is-primary is-light  m-4">
    <p className="title is-2">3</p><Link to="chapterthree"><p className="title is-4 is-family-sans-serif">The US-China Trade War and Myths about Intellectual Property and Innovation in China </p></Link>
			<p className="subtitle">Dan Prud’homme</p>
    </article>
    
    
    </div>
    <div className="tile is-ancestor m-4 is-fluid">
    
    <article className="tile is-child notification is-primary ">
    <p className="title is-2">4</p><Link to="chapterfour"><p className="title is-4 is-family-sans-serif">Global Implications of China’s Policies on Indigenous Innovation </p></Link>
			<p className="subtitle">Erik Baark</p>
    </article>
    <article className="tile is-child notification is-white">
    <p className="title is-2">5</p><Link to="chapterfive"><p className="title is-4 is-family-sans-serif">China’s Talent Challenges Revisited</p></Link>
			<p className="subtitle">Cong Cao and Denis Fred Simon</p>
    </article>
    <article className="tile is-child notification is-warning  ">
    <p className="title is-2">6</p><Link to="chaptersix"><p className="title is-4 is-family-sans-serif">China’s International S&amp;T Relations: From Self-Reliance to Active Global Engagement</p></Link>
			<p className="subtitle">Denis Fred Simon</p>
    </article>
  
  <article className="tile is-child notification is-white">
  
  <p className="title is-2">7</p><Link to="chapterseven"><p className="title is-4 is-family-sans-serif">How Does International Collaboration Lead to Radical Innovation in Latecomer Firms?</p></Link>
			<p className="subtitle">Xiaolan Fu, Cintia Külzer-Sacilotto, Haibo Lin and Hongru Xiong</p>
    </article>
    
    </div>
    <div className="tile is-ancestor m-4 is-fluid">
{/*     <article className="tile is-child box  ">
    <p className="subtitle is-4 px-3">Part Two: Industrial Policy Challenges</p>
    <p><span className="subtitle is-4 px-3"></span></p>

    </article> */}

<article className="tile is-child notification is-white">
    <p className="title is-2">8</p><Link to="chapter8"><p className="title is-4 is-family-sans-serif">PRC Industrial Policies Postdate Rather than Lead Economic Activity</p></Link>
			<p class="subtitle">Carsten A. Holz</p>
    </article>

    <article className="tile is-child notification is-warning is-light is-3">
    <p className="title is-2">9</p><Link to="chapternine"><p className="title is-4 is-family-sans-serif">Made in China 2025 and the Proliferation of Intangible Assets </p></Link>
			<p class="subtitle">Anton Malkin</p>
    </article>
  
  <article className="tile is-child notification is-white">
 
  <p className="title is-2">10</p><Link to="chapterten"><p className="title is-4 is-family-sans-serif">Industrial Policy and Competitive Advantage: A Comparative Study of the Cloud Computing Industry in Hangzhou and Shenzhen</p></Link>
			<p class="subtitle">Bai Gao and Yi Ru</p>    </article>

      <article className="tile is-child notification is-danger is-light is-3">
    <p className="title is-2">11</p><Link to="chaptereleven"><p className="title is-4 is-family-sans-serif">Global Value Chains and the Innovation of the Chinese Mobile Phone Industry </p></Link>
			<p class="subtitle">Yuqing Xing</p>
    <p><span className="subtitle is-4 px-5"></span></p>

    </article>
    
    </div>

    <div className="tile is-ancestor m-6 is-fluid">
   

    <article className="tile is-child notification is-light box">
    <p className="title is-2"></p><p className="title is-5">Backmatter</p>
			<p className=""><Link to="tablesfig">List of Tables and Figures</Link></p>
            <p className=""><Link to="contrib">List of Contributors</Link></p>
            <hr />

            <ul className="">
    
    <li><OutboundLink href="https://nuspress.nus.edu.sg/collections/frontpage/products/innovation-and-chinas-global-emergence"><span class="icon">
  <i className="fas fa-book"></i></span>Buy the Book (Asia)</OutboundLink></li>
  
    <li><OutboundLink href="https://press.uchicago.edu/ucp/books/book/distributed/I/bo124042302.html"><span class="icon">
  <i className="fas fa-book"></i></span>Buy the Book (North America)</OutboundLink></li>
    <li>
      
  <Link to="InnovationandChinasGlobalEmergence.pdf">
    <span className="icon-text">
  <span className="icon">
  <i className="fas fa-file-pdf"></i></span>
  <span>Download the Open Access pdf</span>
    
    
  </span></Link></li>
  
  </ul>
            

    </article>
    <article className="tile is-child is-2">

    </article>
 
    </div>
{/* </div> */}

<Footer></Footer>
  </>
      
  )
}